import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AUTH_REDIRECT_EVENT } from "./api";
import { useToast } from "@/hooks/useToast";

export function AuthRedirectWatcher() {
  const navigate = useNavigate();
  const { push } = useToast();
  useEffect(() => {
    function on() {
      push({ message: "Wymagany klucz API", tone: "danger" });
      navigate("/settings");
    }
    window.addEventListener(AUTH_REDIRECT_EVENT, on);
    return () => window.removeEventListener(AUTH_REDIRECT_EVENT, on);
  }, [navigate, push]);
  return null;
}
